// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Syria from '../_raw/flag/icon_flag_syria.png';

export default () => <img src={Syria} alt="Syria" />;
